import { EImportSectionsTarget, EModalSectionMode } from '@constants';
import { ISection } from '@sdk/contracts';
import { Button, Tooltip } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalSection } from '../ModalSection';

import { Icon } from '@/components/Icon';
import { useMutateSection } from '@/store';

type EditSectionProps = {
  section: ISection;
  target: EImportSectionsTarget;
};

export const EditSection: React.FC<EditSectionProps> = ({ target, section }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { updateSection, isWorking } = useMutateSection();
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');
  const titleKey =
    target === EImportSectionsTarget.INTRODUCTION ? 'EDIT_INTRODUCTION_SECTION' : 'EDIT_SECTION';

  const handleSubmit = (
    values: Pick<ISection, 'name' | 'description'>,
    options?: { onSuccess: () => void }
  ) => updateSection({ ...section, ...values }, { onSuccess: options?.onSuccess });

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <>
      <Tooltip title={t(titleKey)}>
        <Button size="large" type="text" onClick={handleOpen} icon={<Icon i="Edit" size={20} />} />
      </Tooltip>
      <ModalSection
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
        initialValues={{ name: section.name, description: section.description }}
        mode={EModalSectionMode.EDIT}
        isLoading={isWorking}
        hideDescription={target === EImportSectionsTarget.INTRODUCTION}
      />
    </>
  );
};
